import { createStyles, makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useDataGridStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '&.MuiDataGrid-root .MuiDataGrid-cell:focus': {
        outline: 'none',
      },
    },
  })
);

export default useDataGridStyles;
